import React from "react";
import { motion } from "framer-motion";
import { unlockedChart, unlockedCopy } from "../../data/reportData";
import { CopingBars } from "../charts/Charts";

const fadeUp = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] },
};

export default function ClosingSections() {
  return (
    <section id="unlocked" className="report-col section-gap" data-testid="section-unlocked">
      <motion.p
        {...fadeUp}
        className="uppercase text-[12.5px] tracking-[0.2em] font-medium mb-5"
        style={{ color: "#00B843" }}
      >
        The payoff
      </motion.p>
      <motion.h2 {...fadeUp} className="section-h2">
        For one in three operators, there was nothing to replace,
      </motion.h2>
      <motion.p {...fadeUp} className="body-text mt-6" style={{ maxWidth: 680 }} data-testid="unlocked-continuation">
        {unlockedCopy[0]}
      </motion.p>

      <motion.div {...fadeUp} className="mt-14 md:mt-20" data-testid="unlocked-chart-title">
        <h3 className="font-display font-medium text-[22px] md:text-[26px] tracking-[-0.01em] text-[#0A0A0A]">
          {unlockedChart.title}
        </h3>
        <div className="h-px bg-[#E3E6EA] mt-4 md:mt-5" />
      </motion.div>

      <motion.div {...fadeUp} className="mt-10 md:mt-14 md:-ml-[56px]" data-testid="unlocked-chart">
        <CopingBars
          bare
          labels={unlockedChart.labels}
          values={unlockedChart.values}
          widths={unlockedChart.widths}
          source={unlockedChart.source}
          testId="unlocked-bars"
        />
      </motion.div>
    </section>
  );
}
